import { FunctionComponent, useCallback } from 'react'
import { useWidgetContext, customEvent } from '@dxp-module/common'
import { LoginContextProvider } from '@dxp-module/login'
import { MyAccountEvents } from '../../../LoginOrSignup/enum/MyAccountEvents'
import SignupContainer from './MiniWidgetSignupContainer'

const MiniWidgetSignup: FunctionComponent = () => {
  const {
    configuration: { dealId },
  } = useWidgetContext()

  const handleLoginSuccess = useCallback(
    (accessToken?: string) => {
      customEvent.emit(MyAccountEvents.ON_LOGIN_SUCCESS, {
        dealId,
        accessToken,
      })
    },
    [dealId]
  )

  return (
    <LoginContextProvider onLoginSuccess={handleLoginSuccess}>
      <SignupContainer withoutRouter={true} />
    </LoginContextProvider>
  )
}

export default MiniWidgetSignup
